import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../util/utils';

export default function IconColumnHeader(params) {
	return (
		<StyledIconColumnHeader className="StyledIconColumnHeader">
			<section className="HeaderLabelText">{labels.OARAnnotation}</section>
		</StyledIconColumnHeader>
	);
}

const StyledIconColumnHeader = styled.section`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: flex-end;
	color: var(--neutrals-900);
	font-size: var(--px-12);
	font-weight: 400;
	line-height: var(--px-16);
`;
